module.exports = __webpack_public_path__ + "public/images/GoogleIcon.92844141e0f053a39992852d5545e2b0.svg";